import { InputHTMLAttributes, useRef } from "react";

import { useT } from "~/i18n/use-t";

export const InputField: React.FC<{
  type?: InputHTMLAttributes<HTMLInputElement>["type"];
  text: string;
  setText: (text: string) => void;
  onEnterPressed?: (text: string) => void;
  className: string;
  placeholder?: string;
  autoFocus?: boolean;
}> = ({
  type = "text",
  text,
  setText,
  onEnterPressed,
  className,
  placeholder,
  autoFocus,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const t = useT();

  return (
    <input
      type={type}
      ref={inputRef}
      value={text}
      onChange={(event) => setText(event.target.value)}
      onKeyDown={(event) => {
        if (event.key === "Enter" && !event.shiftKey) {
          if (text.length == 0) {
            event.preventDefault();
            return;
          }

          if (onEnterPressed) {
            event.preventDefault();
            onEnterPressed(text);
          }
        }
      }}
      className={className}
      placeholder={
        placeholder ?? t({ tx: "general.typeSomethingInputPlaceholder" })
      }
      autoFocus={autoFocus}
    />
  );
};
